(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unika-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('unika-product-shortcut')) {
    customElements.define('unika-product-shortcut', class extends HTMLElement {
      connectedCallback() {
        this.mainProduct = document.querySelector('product-info');
        if (!this.mainProduct) return;
        this.previousY = window.scrollY;
        this.scrollingDown = false;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.update = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const y = window.scrollY;
            const delta = y - this.previousY;
            if (Math.abs(delta) > 2) {
              this.scrollingDown = delta > 0;
              this.previousY = y;
            }
            const buyButton = this.mainProduct.querySelector('product-form [name="add"]');
            const footer = document.querySelector('footer');
            const atFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
            const overlayOpen = document.querySelector('header details[open], dialog[open], .drawer.active');
            this.hidden = !(window.innerWidth < 750 && this.scrollingDown && buyButton &&
              buyButton.getBoundingClientRect().bottom < 0 && !atFooter && !overlayOpen);
          });
        };
        window.addEventListener('scroll', this.update, { passive: true, signal });
        window.addEventListener('resize', this.update, { passive: true, signal });
        document.addEventListener('toggle', this.update, { capture: true, signal });
        this.querySelector('button').addEventListener('click', () => {
          const target = this.mainProduct.querySelector('variant-selects') || this.mainProduct.querySelector('product-form');
          if (!target) return;
          this.hidden = true;
          this.scrollingDown = false;
          const headerHeight = document.querySelector('.header-wrapper')?.getBoundingClientRect().height || 0;
          const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 24;
          window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          target.querySelector('input:checked, select, button, input')?.focus({ preventScroll: true });
        }, { signal });
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
